export { ScaleFade } from './ScaleFade';
export type { ScaleFadeProps } from './ScaleFade';
